var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".station-box-holder:nth-last-child(2) {\n  border-bottom: 1px solid #E9E9E9;\n}\n.rc-pagination {\n    display: inline-block;\n    margin: 30px auto 0;\n}\n.rc-pagination-item {\n    background-color: transparent;\n    border: none;\n    text-align: center;\n}\n.rc-pagination-item a {\n    color: #585858;\n    font-size: 15px;\n    padding: 2px 3px;\n}\n.rc-pagination-item-active a {\n    border-bottom: 3px solid #8AC100;\n}\n.rc-pagination-prev a:after {\n    content: url(" + escape(require("../images/arrow-l.svg")) + ");\n}\n.rc-pagination-next a:after {\n    content: url(" + escape(require("../images/arrow-r.svg")) + ");\n}\n.rc-pagination-prev,\n.rc-pagination-next {\n    border: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./stations/css/app.css
// module id = 1050
// module chunks = 2